// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-ae4630ea]{border-collapse:collapse}table[data-v-ae4630ea],td[data-v-ae4630ea],th[data-v-ae4630ea]{border:.5px solid #000}thead[data-v-ae4630ea]{display:table-row-group}tr td[data-v-ae4630ea]{page-break-inside:avoid}.no-border[data-v-ae4630ea]{border:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
